import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

function initClock(tickCallback) {
  const delay = ((60 - (new Date()).getSeconds()) % 60) * 1000 + 1;
  setTimeout(() => {
    tickCallback();
    setInterval(tickCallback, 60 * 1000);
  }, delay);
}

function initCountdown(tickCallback) {
  tickCallback();
  const delay = ((60 - (new Date()).getSeconds()) % 60) * 1000 + 1;
  setTimeout(() => {
    tickCallback();
    setInterval(tickCallback, 60 * 1000);
  }, delay);
}

export default new Vuex.Store({
  state: {
    initialized: false,
    calendar: [],
    weather: null,
    cats: null,
    astronomy: null,
    quote: null,
    time: new Date(),
    countdown: null,
    countdownTarget: null,
    countdownLabel: null,
  },
  mutations: {
    UPDATE_STATE(state, data) {
      state.calendar = data.calendar;
      state.weather = data.weather;
      state.cats = data.cats;
      state.astronomy = data.astronomy;
      state.quote = data.quote;
      state.initialized = true;
      state.countdownTarget = data.countdown;
      state.countdownLabel = data.countdown_label;
    },
    UPDATE_TIME(state) {
      state.time = new Date();
    },
    UPDATE_COUNTDOWN(state) {
      if (state.countdownTarget) {
        state.countdown = Math.max(state.countdownTarget * 1000 - new Date().getTime(), 0);
      } else {
        state.countdown = null;
      }
    },
  },
  actions: {
    init({ commit, dispatch }) {
      initClock(() => {
        commit('UPDATE_TIME');
      });
      setTimeout(() => {
        initCountdown(() => {
          commit('UPDATE_COUNTDOWN');
        });
      }, 3000);
      dispatch('update');
      setInterval(() => {
        dispatch('update');
      }, 2 * 60 * 1000);
    },
    async update({ commit }) {
      const data = await fetch('https://dashboard.waboodoo.ch/api/data')
        .then((response) => response.json());
      commit('UPDATE_STATE', data);
    },
  },
});
